export default "__VITE_ASSET__CqywYEfD__"